// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsPatientEventForm__wrapper__2GT4J","submitResult":"SettingsPatientEventForm__submitResult__2RPaA","actionWrapper":"SettingsPatientEventForm__actionWrapper__3UJu7","wrapper2faOptions":"SettingsPatientEventForm__wrapper2faOptions__R9ICe"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SettingsPatientEvents/SettingsPatientEventForm.css
// module id = 578
// module chunks = 0